import { render } from "./Chart.vue?vue&type=template&id=6a5dbef0&scoped=true"
import script from "./Chart.vue?vue&type=script&lang=js"
export * from "./Chart.vue?vue&type=script&lang=js"

import "./Chart.vue?vue&type=style&index=0&id=6a5dbef0&scoped=true&lang=scss"

import exportComponent from "/var/www/mbp-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a5dbef0"]])

export default __exports__